const CryptoJS = require("crypto-js");
export default {
    encrypt: () => {
        const message = "sakshi";
        const secretKey = "sakshi";
        const encryptedMessage = CryptoJS.AES.encrypt(message, secretKey).toString();
        return encryptedMessage;
    },
    decrypt: (key) => {
        const secretKey = "sakshi";
        const bytes = CryptoJS.AES.decrypt(key, secretKey);
        const decryptedMessage = bytes.toString(CryptoJS.enc.Utf8);
        return decryptedMessage;
    }
}